import { Account, AccountId, ApiResponse, Beneficiary, BeneficiaryRequest, UserId } from '@arrived/models';

import { api } from './api';
import { unwrapApiResponse } from './utils';

export const getPrimaryAccount = async (userId?: UserId) => {
  if (!userId) {
    return {} as Account;
  }

  const response = await api.get<ApiResponse<Account>>(`/users/${userId}/accounts/primary`, {
    validateStatus: (status) => status === 404 || status < 300,
  });

  return unwrapApiResponse(response.data);
};

export const getAccountBeneficiaries = async (accountId: AccountId) => {
  const response = await api.get<ApiResponse<Beneficiary[]>>(`/users/accounts/${accountId}/beneficiaries`);

  return unwrapApiResponse(response.data);
};

export const putAccountBeneficiaries = async (accountId: AccountId, request: BeneficiaryRequest[]) => {
  const response = await api.put<ApiResponse<Beneficiary[]>>(`/users/accounts/${accountId}/beneficiaries`, request);

  return unwrapApiResponse(response.data);
};
